export const changeStatusConstants = {
  CHANGE_REQUEST: "CHANGE_STATUS_REQUEST",
  CHANGE_SUCCESS: "CHANGE_STATUS_SUCCESS",
  CHANGE_FAILURE: "CHANGE_STATUS_FAILURE"
};
